import * as actions from "./actions";

const initialState = {
	items: [],
	filter: [],
	pages: null,
	count: 0,
	loading: {}
};

const reducer = function (state = initialState, { type, payload }) {
	switch (type) {
		case actions.GET_CLIENTS: {
			return {
				...state,
				loading: { getAll: true }
			};
		}
		case actions.GET_CLIENTS_SUCCESS: {
			return {
				...state,
				items: payload ? payload : [],
				loading: { getAll: false }
			};
		}
		case actions.GET_CLIENTS_ERROR: {
			return {
				...state,
				errors: payload,
				loading: { getAll: false }
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
